var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex mr-4"},[_c('b-form-select',{attrs:{"options":_vm.listSortOptions},on:{"change":_vm.setKindSort},model:{value:(_vm.selectedOption),callback:function ($$v) {_vm.selectedOption=$$v},expression:"selectedOption"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }